;(function() {
  'use strict'

  angular.module('app.page').directive('moduleCommunity', Directive)

  /* @ngInject */
  function Directive() {
    controller.$inject = ["$q", "$scope", "glAnalytics", "communityService", "userService"];
    return {
      restrict: 'E',
      scope: {
        module: '=',
        page: '=',
      },
      templateUrl: 'module-community.template.html',
      link: link,
      controller: controller,
    }

    function link(scope, elem) {
      elem.addClass('module-community')
    }

    /* @ngInject */
    function controller(
      $q,
      $scope,
      glAnalytics,
      communityService,
      userService
    ) {
      var pageId = $scope.page.id

      $scope.community = communityService.get($scope.module.data.elementId)

      $scope.join = join
      $scope.leave = leave

      function join() {
        track('ClickToJoin', pageId)
        requireUser().then(function() {
          $scope.community.join().then(function() {
            track('DidJoin', pageId)
          })
        })
      }

      function leave() {
        track('ClickToLeave', pageId)
        requireUser().then(function() {
          communityService.confirmLeave().then(function() {
            $scope.community.leave().then(function() {
              track('DidLeave', pageId)
            })
          })
        })
      }

      function requireUser() {
        return $q(function(resolve, reject) {
          if (userService.loggedIn()) {
            return resolve()
          }

          userService
            .promptLogin('Please sign in with Glow to join the crowd')
            .then(function() {
              track('LoggedIn', pageId)
              return communityService.getAll().promise
            }, reject)
            .then(resolve, reject)
        })
      }

      function track(action, label) {
        glAnalytics.track('PageCrowdModule', action, label)
      }
    }
  }
})()
